import { jwtDecode } from 'jwt-decode';
import sign from 'jwt-encode';

const SECRET = 'qrcodestyling_56llP0s';

export const decode = (token: string) => jwtDecode(token);

export const encode = (token: any) => sign(token, SECRET);
